import React from "react";
import styles from "./StatDisplay.module.css";

const StatDisplay = ({ stats = [], className }) => {
	return (
		<div className={`${styles.statsContainer} ${className || ""}`}>
			{stats.map((stat, index) => (
				<div key={index} className={styles.stat}>
					<span className={styles.label}>{stat.label}</span>
					<span
						className={`${styles.value} ${
							stat.variant ? styles[stat.variant] : ""
						}`}
					>
						{stat.value}
					</span>
				</div>
			))}
		</div>
	);
};

export default StatDisplay;
